(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function ciwiFilterValues(el) {
    if (!el) return [];
    if (el.tagName === "SELECT") return el.value ? [el.value] : [];
    return Array.from(el.querySelectorAll('input[type="checkbox"]:checked'))
      .map((input) => input.value)
      .filter(Boolean);
  }

  function ciwiHandleize(name) {
    return String(name || "")
      .toLowerCase()
      .replace(/['’]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function ciwiOptionsAttrFromJsonProduct(product) {
    const parts = [];
    (product.options || []).forEach((opt) => {
      const handle = ciwiHandleize(opt.name);
      const values = Array.isArray(opt.values) ? opt.values.filter(Boolean) : [];
      if (handle && values.length) parts.push(handle + "=" + values.join("|||"));
    });
    return parts.join(";;");
  }

  function ciwiCatImagesAttrFromJsonProduct(product) {
    const options = product.options || [];
    let catIndex = -1;
    options.forEach((opt, index) => {
      if (ciwiHandleize(opt.name) === "category") catIndex = index;
    });
    if (catIndex < 0) return "";
    const key = "option" + String(catIndex + 1);
    const imageById = {};
    (product.images || []).forEach((img) => {
      if (img && img.id) imageById[img.id] = img.src || "";
    });
    const seen = {};
    const parts = [];
    (product.variants || []).forEach((variant) => {
      const val = String(variant[key] || "").trim();
      if (!val || seen[val.toLowerCase()]) return;
      let src = "";
      if (variant.featured_image && variant.featured_image.src) src = variant.featured_image.src;
      else if (variant.image_id && imageById[variant.image_id]) src = imageById[variant.image_id];
      if (!src) return;
      seen[val.toLowerCase()] = true;
      parts.push(val + "=" + src);
    });
    return parts.join("|||");
  }

  function ciwiCatImageMap(item) {
    const raw = item.getAttribute("data-ciwi-cat-images") || "";
    const map = {};
    if (!raw) return map;
    raw.split("|||").forEach((part) => {
      const eq = part.indexOf("=");
      if (eq <= 0) return;
      map[part.slice(0, eq).trim().toLowerCase()] = part.slice(eq + 1).trim();
    });
    return map;
  }

  function ciwiSelectedCategoryValues(panel) {
    const values = [];
    panel.querySelectorAll("[data-ciwi-filter]").forEach((el) => {
      const kind = ciwiFilterKind(el);
      const param = ciwiFilterParam(el);
      if (kind !== "category" && param.indexOf("option.category") === -1) return;
      ciwiFilterValues(el).forEach((value) => values.push(String(value).toLowerCase()));
    });
    return values;
  }

  function ciwiPrimaryCardImages(item) {
    const wrap = item.querySelector("[data-product-card-image]") || item.querySelector(".grid__image");
    if (!wrap) return [];
    const nodes = wrap.tagName === "IMG" ? [wrap] : Array.from(wrap.querySelectorAll("img"));
    return nodes.filter((img) => {
      if (img.closest(".product-card__image--secondary")) return false;
      if (img.closest(".product-card__image--swatch")) return false;
      if (img.hasAttribute("data-product-card-swatch-image")) return false;
      return true;
    });
  }

  function ciwiRememberOriginalImage(item) {
    if (item.getAttribute("data-ciwi-img-orig")) return;
    const img = ciwiPrimaryCardImages(item)[0];
    if (!img) return;
    item.setAttribute("data-ciwi-img-orig", img.getAttribute("src") || img.currentSrc || "");
    item.setAttribute("data-ciwi-img-orig-srcset", img.getAttribute("srcset") || "");
  }

  function ciwiSetCardImage(item, url) {
    if (!url) return;
    ciwiRememberOriginalImage(item);
    item.classList.add("ciwi-tabs__product--cat-img");
    ciwiPrimaryCardImages(item).forEach((img) => {
      const picture = img.closest("picture");
      if (picture) {
        picture.querySelectorAll("source").forEach((source) => source.removeAttribute("srcset"));
      }
      img.setAttribute("src", url);
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
      img.removeAttribute("data-src");
      img.removeAttribute("data-srcset");
    });
  }

  function ciwiRestoreCardImage(item) {
    item.classList.remove("ciwi-tabs__product--cat-img");
    const orig = item.getAttribute("data-ciwi-img-orig");
    if (!orig) return;
    ciwiPrimaryCardImages(item).forEach((img) => {
      img.setAttribute("src", orig);
      const srcset = item.getAttribute("data-ciwi-img-orig-srcset");
      if (srcset) img.setAttribute("srcset", srcset);
      else img.removeAttribute("srcset");
    });
  }

  function ciwiSyncCardImages(panel) {
    const wanted = ciwiSelectedCategoryValues(panel);
    panel.querySelectorAll("[data-ciwi-product]").forEach((item) => {
      if (!wanted.length) {
        ciwiRestoreCardImage(item);
        return;
      }
      const map = ciwiCatImageMap(item);
      let url = "";
      for (let i = 0; i < wanted.length; i += 1) {
        if (map[wanted[i]]) {
          url = map[wanted[i]];
          break;
        }
      }
      if (url) ciwiSetCardImage(item, url);
      else ciwiRestoreCardImage(item);
    });
  }

  function ciwiOptionMap(item) {
    const raw = item.getAttribute("data-ciwi-options") || "";
    const map = {};
    if (!raw) return map;
    raw.split(";;").forEach((part) => {
      const eq = part.indexOf("=");
      if (eq <= 0) return;
      const handle = part.slice(0, eq).trim().toLowerCase();
      map[handle] = part
        .slice(eq + 1)
        .split("|||")
        .map((s) => s.trim())
        .filter(Boolean);
    });
    return map;
  }

  function ciwiFilterParam(el) {
    return String((el && el.getAttribute("data-ciwi-filter")) || "");
  }

  function ciwiFilterKind(el) {
    const type = String((el && el.getAttribute("data-ciwi-filter-type")) || "");
    if (type) return type;
    const param = ciwiFilterParam(el);
    if (param.indexOf("availability") !== -1 || param === "availability") return "availability";
    if (param.indexOf("price") !== -1 || param === "price") return "price";
    if (param.indexOf("option.category") !== -1) return "category";
    if (param.indexOf("product_type") !== -1 || param === "type") return "product_type";
    if (param.indexOf("vendor") !== -1) return "vendor";
    if (param.indexOf("filter.p.tag") !== -1 || param === "tag") return "tag";
    return param;
  }

  function ciwiProductFacetValues(item, el) {
    const param = ciwiFilterParam(el);
    const kind = ciwiFilterKind(el);
    if (kind === "availability" || param.indexOf("availability") !== -1) {
      return item.getAttribute("data-available") === "true" ? ["1"] : ["0"];
    }
    if (kind === "price" || param.indexOf("price") !== -1) return [];
    if (kind === "vendor" || (param.indexOf("vendor") !== -1 && param.indexOf("option.") === -1)) {
      const vendor = item.getAttribute("data-vendor") || "";
      return vendor ? [vendor] : [];
    }
    if (kind === "product_type" || param.indexOf("product_type") !== -1 || param === "type") {
      const typeValue = item.getAttribute("data-type") || "";
      return typeValue ? [typeValue] : [];
    }
    if (kind === "tag" || param.indexOf("filter.p.tag") !== -1) {
      try {
        const tags = JSON.parse(item.getAttribute("data-tags") || "[]");
        return Array.isArray(tags) ? tags.map(String) : [];
      } catch (error) {
        return [];
      }
    }
    const optionPrefixV = "filter.v.option.";
    const optionPrefixP = "filter.p.option.";
    let handle = "";
    if (param.indexOf(optionPrefixV) === 0) handle = param.slice(optionPrefixV.length);
    else if (param.indexOf(optionPrefixP) === 0) handle = param.slice(optionPrefixP.length);
    if (handle) return ciwiOptionMap(item)[handle] || [];
    return [];
  }

  function ciwiValueMatchesWanted(productVals, wanted) {
    const wantedDown = wanted.map((item) => String(item).toLowerCase());
    return productVals.some((val) => {
      const down = String(val).toLowerCase();
      if (wantedDown.indexOf(down) !== -1) return true;
      if (down === "true" && wantedDown.indexOf("1") !== -1) return true;
      if (down === "false" && wantedDown.indexOf("0") !== -1) return true;
      if (down === "1" && (wantedDown.indexOf("true") !== -1 || wantedDown.indexOf("in-stock") !== -1)) return true;
      if (down === "0" && (wantedDown.indexOf("false") !== -1 || wantedDown.indexOf("out-of-stock") !== -1)) return true;
      return false;
    });
  }

  function ciwiSyncMultiFilterLabel(el) {
    const trigger = el.querySelector(".ciwi-tabs__multi-trigger");
    if (!trigger) return;
    const values = ciwiFilterValues(el);
    const fallback = trigger.getAttribute("data-placeholder") || "Category";
    trigger.textContent = fallback;
    if (!values.length) return;
    const badge = document.createElement("span");
    badge.className = "ciwi-tabs__multi-count";
    badge.textContent = String(values.length);
    trigger.appendChild(badge);
  }

  function ciwiActiveFilterEntries(panel) {
    const entries = [];
    panel.querySelectorAll("[data-ciwi-filter]").forEach((el) => {
      const kind = el.getAttribute("data-ciwi-filter");
      const filterKind = ciwiFilterKind(el);
      ciwiFilterValues(el).forEach((value) => {
        let label = value;
        if (el.tagName === "SELECT") {
          const option = Array.from(el.options).find((item) => item.value === value);
          if (option) label = option.textContent.trim();
        } else {
          const box = Array.from(el.querySelectorAll("input")).find(
            (input) => String(input.value) === String(value)
          );
          if (box) {
            const named = (box.getAttribute("data-label") || "").trim();
            const fallback = ((box.parentNode && box.parentNode.textContent) || "").trim();
            label = named || fallback || value;
          }
        }
        if (filterKind === "availability" && (!label || label === value)) {
          if (value === "1" || value === "true") label = "In stock";
          if (value === "0" || value === "false") label = "Out of stock";
        }
        entries.push({ kind, value, label });
      });
    });
    return entries;
  }

  function ciwiRenderActiveFilters(panel) {
    const root = panel.querySelector("[data-ciwi-active-filters]");
    if (!root) return;
    const entries = ciwiActiveFilterEntries(panel);
    root.hidden = entries.length === 0;
    root.replaceChildren();
    if (!entries.length) return;
    const clear = document.createElement("button");
    clear.type = "button";
    clear.className = "ciwi-tabs__active-clear";
    clear.setAttribute("data-ciwi-filter-clear-all", "");
    clear.textContent = "Clear all";
    root.appendChild(clear);
    entries.forEach((entry) => {
      const chip = document.createElement("button");
      chip.type = "button";
      chip.className = "ciwi-tabs__active-chip";
      chip.setAttribute("data-ciwi-filter-clear", entry.kind);
      chip.setAttribute("data-value", entry.value);
      chip.setAttribute("aria-label", "Remove filter " + entry.label);
      const text = document.createElement("span");
      text.textContent = entry.label;
      const x = document.createElement("span");
      x.className = "ciwi-tabs__active-chip-x";
      x.setAttribute("aria-hidden", "true");
      x.innerHTML = '<svg viewBox="0 0 12 12"><path d="M2 2l8 8M10 2 2 10" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
      chip.appendChild(text);
      chip.appendChild(x);
      root.appendChild(chip);
    });
  }

  function ciwiClearFilterValue(panel, kind, value) {
    panel.querySelectorAll('[data-ciwi-filter="' + kind + '"]').forEach((el) => {
      if (el.tagName === "SELECT") {
        el.value = "";
        return;
      }
      el.querySelectorAll('input[type="checkbox"]').forEach((box) => {
        if (String(box.value) === String(value)) box.checked = false;
      });
      ciwiSyncMultiFilterLabel(el);
    });
  }

  function ciwiClearAllFilters(panel) {
    panel.querySelectorAll("[data-ciwi-filter]").forEach((el) => {
      if (el.tagName === "SELECT") {
        el.value = "";
        return;
      }
      el.querySelectorAll('input[type="checkbox"]').forEach((box) => {
        box.checked = false;
      });
      ciwiSyncMultiFilterLabel(el);
    });
  }

  function ciwiCloseMultiFilters(except) {
    document.querySelectorAll("[data-ciwi-multi].is-open").forEach((el) => {
      if (el === except) return;
      const menu = el.querySelector(".ciwi-tabs__multi-menu");
      const trigger = el.querySelector(".ciwi-tabs__multi-trigger");
      if (menu) menu.hidden = true;
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      el.classList.remove("is-open");
    });
  }

  function ciwiBindMultiFilters(panel) {
    panel.querySelectorAll("[data-ciwi-multi]").forEach((el) => {
      const trigger = el.querySelector(".ciwi-tabs__multi-trigger");
      const menu = el.querySelector(".ciwi-tabs__multi-menu");
      if (!trigger || !menu || trigger._ciwiMultiBound) return;
      trigger._ciwiMultiBound = true;
      ciwiSyncMultiFilterLabel(el);
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const open = menu.hidden;
        ciwiCloseMultiFilters(el);
        menu.hidden = !open;
        trigger.setAttribute("aria-expanded", open ? "true" : "false");
        el.classList.toggle("is-open", open);
      });
      el.addEventListener("click", (event) => event.stopPropagation());
      el.addEventListener("change", () => ciwiSyncMultiFilterLabel(el));
    });
  }

  function ciwiFilterStorageKey(root, panel) {
    const sectionId = (root && root.getAttribute("data-section-id")) || "";
    const tab = (panel && panel.getAttribute("data-panel")) || "";
    return "ciwi-tabs-filter:" + sectionId + ":" + tab;
  }

  function ciwiFilterRememberEnabled() {
    return !(window.Shopify && window.Shopify.designMode);
  }

  function ciwiReadSavedFilters(root, panel) {
    if (!ciwiFilterRememberEnabled()) return null;
    try {
      const raw = window.localStorage.getItem(ciwiFilterStorageKey(root, panel));
      if (!raw) return null;
      const saved = JSON.parse(raw);
      return saved && typeof saved === "object" ? saved : null;
    } catch (error) {
      return null;
    }
  }

  function ciwiWriteSavedFilters(root, panel) {
    if (!ciwiFilterRememberEnabled()) return;
    try {
      const payload = {};
      panel.querySelectorAll("[data-ciwi-filter]").forEach((el) => {
        payload[el.getAttribute("data-ciwi-filter")] = ciwiFilterValues(el);
      });
      const sort = panel.querySelector("[data-ciwi-sort]");
      if (sort) payload.sort = sort.value;
      window.localStorage.setItem(ciwiFilterStorageKey(root, panel), JSON.stringify(payload));
    } catch (error) {}
  }

  function ciwiApplySavedFilters(panel, saved) {
    if (!saved) return false;
    panel.querySelectorAll("[data-ciwi-filter]").forEach((el) => {
      const kind = el.getAttribute("data-ciwi-filter");
      if (!Object.prototype.hasOwnProperty.call(saved, kind)) return;
      const values = Array.isArray(saved[kind]) ? saved[kind] : saved[kind] ? [saved[kind]] : [];
      if (el.tagName === "SELECT") {
        el.value = values[0] || "";
        return;
      }
      const wanted = values.map((item) => String(item).toLowerCase());
      el.querySelectorAll('input[type="checkbox"]').forEach((box) => {
        box.checked = wanted.indexOf(String(box.value).toLowerCase()) !== -1;
      });
      ciwiSyncMultiFilterLabel(el);
    });
    if (saved.sort) {
      const sort = panel.querySelector("[data-ciwi-sort]");
      if (sort) {
        const match = Array.from(sort.options).find((option) => option.value === saved.sort);
        if (match) sort.value = match.value;
      }
    }
    return true;
  }

  function ciwiApplyDefaultFilters(panel) {
    const availability = (panel.getAttribute("data-default-availability") || "").trim();
    const category = (panel.getAttribute("data-default-category") || "").trim();
    const hasOptionCategory = Array.from(panel.querySelectorAll("[data-ciwi-filter]")).some((el) => {
      return ciwiFilterKind(el) === "category" || ciwiFilterParam(el).indexOf("option.category") !== -1;
    });
    if (availability) {
      panel.querySelectorAll("[data-ciwi-filter]").forEach((el) => {
        if (ciwiFilterKind(el) !== "availability" && ciwiFilterParam(el).indexOf("availability") === -1) return;
        const wanted = String(availability);
        if (el.tagName === "SELECT") {
          const match = Array.from(el.options).find((option) => {
            const value = String(option.value);
            if (value === wanted) return true;
            if (wanted === "1") return value === "true" || value === "in-stock" || value === "available";
            if (wanted === "0") return value === "false" || value === "out-of-stock" || value === "unavailable";
            return false;
          });
          if (match) el.value = match.value;
          return;
        }
        el.querySelectorAll('input[type="checkbox"]').forEach((box) => {
          const value = String(box.value).toLowerCase();
          box.checked =
            value === wanted ||
            (wanted === "1" && (value === "true" || value === "in-stock" || value === "available")) ||
            (wanted === "0" && (value === "false" || value === "out-of-stock" || value === "unavailable"));
        });
        ciwiSyncMultiFilterLabel(el);
      });
    }
    if (category) {
      const wanted = category
        .split(/[,;|，、\n]/)
        .map((item) => item.trim().toLowerCase())
        .filter(Boolean);
      panel.querySelectorAll("[data-ciwi-filter]").forEach((el) => {
        const kind = ciwiFilterKind(el);
        const param = ciwiFilterParam(el);
        const isOptionCat = kind === "category" || param.indexOf("option.category") !== -1;
        const isProductType = kind === "product_type" || param.indexOf("product_type") !== -1 || param === "type";
        if (!isOptionCat && !(isProductType && !hasOptionCategory)) return;
        if (el.tagName === "SELECT") {
          const match = Array.from(el.options).find((option) => wanted.indexOf(String(option.value).toLowerCase()) !== -1);
          if (match) el.value = match.value;
        } else {
          el.querySelectorAll('input[type="checkbox"]').forEach((box) => {
            const value = String(box.value).toLowerCase();
            const label = String(box.getAttribute("data-label") || "").toLowerCase();
            box.checked = wanted.indexOf(value) !== -1 || (label && wanted.indexOf(label) !== -1);
          });
          ciwiSyncMultiFilterLabel(el);
        }
      });
    }
    ciwiApplyCollectionFilters(panel, false);
  }

  function ciwiApplyCollectionFilters(panel, allowReorder) {
    const list = panel.querySelector("[data-ciwi-products]");
    if (!list) return;
    const items = Array.from(list.querySelectorAll("[data-ciwi-product]"));
    const filters = Array.from(panel.querySelectorAll("[data-ciwi-filter]"));
    const sort = panel.querySelector("[data-ciwi-sort]");
    const empty = panel.querySelector("[data-ciwi-filter-empty]");
    let visible = 0;

    items.forEach((item) => {
      let show = true;
      filters.forEach((sel) => {
        const values = ciwiFilterValues(sel);
        if (!values.length || !show) return;
        const kind = ciwiFilterKind(sel);
        const param = ciwiFilterParam(sel);
        if (kind === "price" || param.indexOf("price") !== -1) {
          const value = values[0];
          const price = Number(item.getAttribute("data-price") || 0);
          const parts = String(value).split(":");
          const min = Number(parts[0] || 0);
          const max = parts[1] === "" || parts[1] == null ? null : Number(parts[1]);
          if (price < min) show = false;
          if (max !== null && price >= max) show = false;
          return;
        }
        const productVals = ciwiProductFacetValues(item, sel);
        const canMatch =
          kind === "availability" ||
          kind === "category" ||
          kind === "product_type" ||
          kind === "vendor" ||
          kind === "tag" ||
          param.indexOf("option.") !== -1 ||
          param.indexOf("product_type") !== -1 ||
          param.indexOf("availability") !== -1 ||
          (param.indexOf("vendor") !== -1 && param.indexOf("option.") === -1) ||
          param.indexOf("filter.p.tag") !== -1;
        if (!canMatch && !productVals.length) return;
        if (!ciwiValueMatchesWanted(productVals, values)) show = false;
      });
      item.classList.toggle("ciwi-tabs__product--off", !show);
      if (show && !item.classList.contains("ciwi-tabs__product--capped")) visible += 1;
    });

    if (allowReorder === false) {
      const root = panel.closest("[data-collection-tabs]");
      if (root) ciwiEnforceCardCap(panel, root);
      if (empty) empty.hidden = visible !== 0;
      ciwiRenderActiveFilters(panel);
      ciwiSyncCardImages(panel);
      return;
    }

    const mode = sort ? sort.value : "manual";
    const sorted = items.slice().sort((a, b) => {
      const priceA = Number(a.getAttribute("data-price") || 0);
      const priceB = Number(b.getAttribute("data-price") || 0);
      const titleA = (a.getAttribute("data-title") || "").toLowerCase();
      const titleB = (b.getAttribute("data-title") || "").toLowerCase();
      const createdA = Number(a.getAttribute("data-created") || 0);
      const createdB = Number(b.getAttribute("data-created") || 0);
      const indexA = Number(a.getAttribute("data-index") || 0);
      const indexB = Number(b.getAttribute("data-index") || 0);
      if (mode === "price-ascending") return priceA - priceB;
      if (mode === "price-descending") return priceB - priceA;
      if (mode === "title-ascending") return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
      if (mode === "title-descending") return titleA > titleB ? -1 : titleA < titleB ? 1 : 0;
      if (mode === "created-ascending") return createdA - createdB;
      if (mode === "created-descending") return createdB - createdA;
      return indexA - indexB;
    });
    let orderChanged = false;
    for (let i = 0; i < items.length; i += 1) {
      if (items[i] !== sorted[i]) {
        orderChanged = true;
        break;
      }
    }
    if (orderChanged) {
      const anchor = ciwiScrollAnchor(list);
      const fragment = document.createDocumentFragment();
      sorted.forEach((item) => fragment.appendChild(item));
      list.appendChild(fragment);
      if (anchor) {
        const delta = anchor.node.getBoundingClientRect().top - anchor.top;
        if (delta) window.scrollBy(0, delta);
      }
    }
    if (empty) empty.hidden = visible !== 0;
    const root = panel.closest("[data-collection-tabs]");
    if (root) ciwiEnforceCardCap(panel, root);
    ciwiRenderActiveFilters(panel);
    ciwiSyncCardImages(panel);
  }

  function ciwiScrollAnchor(list) {
    const nodes = list.querySelectorAll("[data-ciwi-product]");
    for (let i = 0; i < nodes.length; i += 1) {
      if (nodes[i].classList.contains("ciwi-tabs__product--off")) continue;
      if (nodes[i].classList.contains("ciwi-tabs__product--capped")) continue;
      const rect = nodes[i].getBoundingClientRect();
      if (rect.bottom > 80 && rect.top < window.innerHeight) return { node: nodes[i], top: rect.top };
    }
    return null;
  }

  function ciwiYotpoReady() {
    try {
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === "function") return true;
      if (window.yotpo && typeof window.yotpo.refreshWidgets === "function") return true;
      if (typeof yotpo !== "undefined" && yotpo && typeof yotpo.initWidgets === "function") return true;
    } catch (error) {}
    return false;
  }

  function ciwiRefreshYotpo(deep) {
    try {
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === "function") {
        window.yotpoWidgetsContainer.initWidgets();
      }
      if (window.yotpo && typeof window.yotpo.refreshWidgets === "function") {
        window.yotpo.refreshWidgets();
      }
      if (deep && typeof yotpo !== "undefined" && yotpo && typeof yotpo.initWidgets === "function") {
        yotpo.initWidgets();
      }
    } catch (error) {}
  }

  function ciwiRatingShowEnabled(root) {
    if (!root) return false;
    return root.getAttribute("data-show-rating") === "on" && !root.classList.contains("ciwi-tabs--hide-rating");
  }

  function ciwiRatingWrapHasContent(wrap) {
    if (!wrap) return false;
    if (wrap.querySelector(".reviews-star-rating.has-rating")) return true;
    if (wrap.querySelector(".yotpo .star-container, .yotpo .yotpo-stars, .yotpo-bottomline, .yotpo .text-m")) return true;
    // Bare .yotpo.bottomLine shells / leftover placeholders do not count.
    const clone = wrap.cloneNode(true);
    clone.querySelectorAll(".yotpo, .ciwi-card-stars, script, style").forEach((node) => node.remove());
    return (clone.textContent || "").replace(/\s+/g, "").length > 0;
  }

  function ciwiRatingGraceActive(root) {
    const at = root && root._ciwiRatingUpgradeAt ? root._ciwiRatingUpgradeAt : 0;
    const rebootUntil = root && root._ciwiRatingRebootUntil ? root._ciwiRatingRebootUntil : 0;
    return Date.now() - at < 5000 || Date.now() < rebootUntil;
  }

  function ciwiYotpoShell(wrap) {
    if (!wrap) return false;
    return Boolean(
      wrap.querySelector(".yotpo.bottomLine[data-product-id], .yotpo.bottomLine[data-yotpo-product-id]")
    );
  }

  function ciwiMarkRatingUpgrade(root) {
    if (root) root._ciwiRatingUpgradeAt = Date.now();
  }

  function ciwiEnsureRatingWrap(item, productId) {
    let wrap = item.querySelector(".product-grid--rating");
    if (wrap) return wrap;
    const card = item.querySelector("product-card") || item;
    const price = card.querySelector(".product-grid--price");
    wrap = document.createElement("div");
    wrap.className = "product-grid--rating ciwi-tabs__yotpo-rating";
    wrap.setAttribute("data-ciwi-rating-wrap", "");
    wrap.setAttribute("data-ciwi-rating-source", "yotpo");
    if (price && price.parentNode) price.parentNode.insertBefore(wrap, price.nextSibling);
    else card.appendChild(wrap);
    return wrap;
  }

  function ciwiMountYotpoShell(wrap, productId) {
    wrap.innerHTML = "";
    wrap.classList.add("ciwi-tabs__yotpo-rating");
    wrap.removeAttribute("hidden");
    const widget = document.createElement("div");
    widget.className = "yotpo bottomLine";
    widget.setAttribute("data-ciwi-yotpo", "1");
    widget.setAttribute("data-product-id", productId);
    widget.setAttribute("data-yotpo-product-id", productId);
    wrap.appendChild(widget);
  }

  function ciwiScheduleRatingSync(root, scope) {
    const area = scope || root;
    [80, 600, 1600, 2800, 4200, 6000].forEach((delay) => {
      window.setTimeout(() => ciwiSyncRatingVisibility(root, area), delay);
    });
  }

  function ciwiRebootstrapRatings(root) {
    if (!ciwiRatingShowEnabled(root)) {
      ciwiSyncRatingVisibility(root, root);
      return;
    }
    ciwiMarkRatingUpgrade(root);
    root._ciwiRatingRebootUntil = Date.now() + 8000;
    root.querySelectorAll("[data-ciwi-product]").forEach((item) => {
      const productId = item.getAttribute("data-product-id");
      if (!productId) return;
      const wrap = ciwiEnsureRatingWrap(item, productId);
      ciwiMountYotpoShell(wrap, productId);
    });
    ciwiRefreshYotpo(true);
    let tries = 0;
    const tick = () => {
      if (!root.isConnected || !ciwiRatingShowEnabled(root)) return;
      if (ciwiYotpoReady()) ciwiRefreshYotpo(true);
      tries += 1;
      if (tries < 10 && !ciwiYotpoReady()) window.setTimeout(tick, 350);
    };
    tick();
    ciwiScheduleRatingSync(root, root);
  }

  function ciwiBindRatingSettingObserver(root) {
    if (!root || root._ciwiRatingSettingObs) return;
    const readEnabled = () => ciwiRatingShowEnabled(root);
    root._ciwiRatingShowWas = readEnabled();
    root._ciwiRatingSettingObs = new MutationObserver(() => {
      const enabled = readEnabled();
      const was = root._ciwiRatingShowWas;
      root._ciwiRatingShowWas = enabled;
      if (enabled && !was) ciwiRebootstrapRatings(root);
      else if (!enabled) ciwiSyncRatingVisibility(root, root);
    });
    root._ciwiRatingSettingObs.observe(root, {
      attributes: true,
      attributeFilter: ["data-show-rating", "class"]
    });
  }

  function ciwiSyncRatingVisibility(root, scope) {
    if (!root) return;
    const show = ciwiRatingShowEnabled(root);
    const area = scope || root;
    const grace = show && ciwiRatingGraceActive(root);
    area.querySelectorAll(".product-grid--rating").forEach((wrap) => {
      if (!show) {
        wrap.setAttribute("hidden", "");
        return;
      }
      // Strip leftover fake placeholders from older drafts.
      wrap.querySelectorAll(".ciwi-card-stars").forEach((node) => node.remove());
      if (ciwiRatingWrapHasContent(wrap)) {
        wrap.removeAttribute("hidden");
        return;
      }
      if (grace && ciwiYotpoShell(wrap)) {
        wrap.removeAttribute("hidden");
        return;
      }
      wrap.setAttribute("hidden", "");
    });
  }

  function ciwiNudgeYotpoRatings(root) {
    if (!ciwiRatingShowEnabled(root)) return;
    ciwiMarkRatingUpgrade(root);
    ciwiRefreshYotpo(true);
    ciwiScheduleRatingSync(root, root);
  }

  function ciwiUpgradeRatings(root, scope) {
    if (!ciwiRatingShowEnabled(root)) {
      ciwiSyncRatingVisibility(root, scope);
      return;
    }
    ciwiMarkRatingUpgrade(root);
    const area = scope || root;
    area.querySelectorAll("[data-ciwi-product]").forEach((item) => {
      const productId = item.getAttribute("data-product-id");
      if (!productId) return;
      const wrap = ciwiEnsureRatingWrap(item, productId);
      if (!wrap.querySelector(".yotpo.bottomLine")) ciwiMountYotpoShell(wrap, productId);
      else {
        const widget = wrap.querySelector(".yotpo.bottomLine");
        widget.setAttribute("data-ciwi-yotpo", "1");
        widget.setAttribute("data-product-id", productId);
        widget.setAttribute("data-yotpo-product-id", productId);
      }
    });
    if (ciwiYotpoReady()) ciwiRefreshYotpo(true);
    ciwiScheduleRatingSync(root, area);
  }

  function ciwiScheduleRatingUpgrade(root) {
    ciwiBindRatingSettingObserver(root);
    if (ciwiRatingShowEnabled(root)) ciwiRebootstrapRatings(root);
    else ciwiSyncRatingVisibility(root, root);
  }

  function ciwiPageSize(root) {
    const fromDom = root ? Number(root.getAttribute("data-page-size")) : NaN;
    const raw = Number.isFinite(fromDom) && fromDom > 0 ? fromDom : 8;
    return Math.max(4, Math.min(24, raw || 8));
  }

  function ciwiCardNodes(list) {
    const preferred = Array.from(list.children).filter((el) => {
      if (el.nodeType !== 1) return false;
      return el.hasAttribute("data-ciwi-product") || el.classList.contains("grid__item");
    });
    if (preferred.length) return preferred;
    return Array.from(list.children).filter((el) => el.nodeType === 1);
  }

  function ciwiVisibleCardCount(panel) {
    const list = panel.querySelector("[data-ciwi-products]");
    if (!list) return 0;
    return ciwiCardNodes(list).filter((card) => {
      return !card.classList.contains("ciwi-tabs__product--capped")
        && !card.classList.contains("ciwi-tabs__product--off");
    }).length;
  }

  function ciwiEnforceCardCap(panel, root) {
    const list = panel.querySelector("[data-ciwi-products]");
    if (!list || !root) return;
    const state = ciwiMoreState(panel);
    const pageSize = ciwiPageSize(root);
    if (!state.cardCap) state.cardCap = pageSize;
    const cards = ciwiCardNodes(list);
    cards.forEach((card, index) => {
      card.classList.toggle("ciwi-tabs__product--capped", index >= state.cardCap);
    });
  }

  function ciwiWatchCardCap(panel, root) {
    const list = panel.querySelector("[data-ciwi-products]");
    if (!list || list._ciwiCardCapObs) return;
    let timer = 0;
    const schedule = () => {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(() => ciwiEnforceCardCap(panel, root), 80);
    };
    const obs = new MutationObserver(schedule);
    obs.observe(list, { childList: true });
    list._ciwiCardCapObs = obs;
    // Variant-split apps often inject cards after first paint.
    [0, 150, 400, 900, 1800, 3200].forEach((ms) => {
      window.setTimeout(() => ciwiEnforceCardCap(panel, root), ms);
    });
  }

  function ciwiMoreState(panel) {
    if (!panel._ciwiMore) {
      // Prefer HTML alternate view first — products.json often hangs/fails in the
      // theme editor. JSON is only a fallback after HTML fails.
      panel._ciwiMore = {
        nextPage: 0,
        done: false,
        busy: false,
        paused: false,
        preferJson: false,
        jsonPage: 1,
        cardCap: 0
      };
    }
    return panel._ciwiMore;
  }

  function ciwiInitialSpuCount(panel) {
    const ids = new Set();
    panel.querySelectorAll("[data-ciwi-product]").forEach((item) => {
      const id = item.getAttribute("data-product-id");
      if (id) ids.add(id);
    });
    return ids.size || panel.querySelectorAll("[data-ciwi-product]").length;
  }

  function ciwiResolveNextPage(root, panel, state) {
    if (state.nextPage > 0) return state.nextPage;
    state.nextPage = 1;
    return 1;
  }

  function ciwiSentinelVisible(sentinel) {
    if (!sentinel) return false;
    const panel = sentinel.closest("[data-panel]");
    if (!panel || !panel.classList.contains("is-active")) return false;
    const rect = sentinel.getBoundingClientRect();
    return rect.width > 0 && rect.top < window.innerHeight + 200 && rect.bottom > 0;
  }

  function ciwiStripLinkedOptions(root) {
    if (!root) return;
    root.querySelectorAll(
      ".king-linked-options-collection__container, [class*='king-linked-options'], .lv-option-box, [class*='lv-option-']"
    ).forEach((node) => node.remove());
  }

  function ciwiWatchLinkedOptions(root) {
    if (!root || root._ciwiLinkedObs) return;
    ciwiStripLinkedOptions(root);
    if (typeof MutationObserver === "undefined") return;
    root._ciwiLinkedObs = new MutationObserver(() => ciwiStripLinkedOptions(root));
    root._ciwiLinkedObs.observe(root, { childList: true, subtree: true });
  }

  function ciwiPrepareItem(panel, item) {
    item.querySelectorAll("script, safe-load-scripts").forEach((node) => node.remove());
    ciwiStripLinkedOptions(item);
    const sample = panel.querySelector("[data-ciwi-product]");
    if (!sample || sample === item) return;
    item.className = sample.className;
    item.classList.remove("ciwi-tabs__product--off");
    const sampleCard = sample.querySelector("product-card");
    const card = item.querySelector("product-card");
    if (!sampleCard || !card) return;
    ["data-grid-count-desktop", "data-grid-count-mobile"].forEach((attr) => {
      const value = sampleCard.getAttribute(attr);
      if (value != null) card.setAttribute(attr, value);
    });
  }

  function ciwiCollectionHandle(panel) {
    const raw = panel.getAttribute("data-ciwi-collection-url") || "";
    try {
      const url = new URL(raw, window.location.origin);
      const parts = url.pathname.split("/").filter(Boolean);
      const idx = parts.indexOf("collections");
      return idx >= 0 ? decodeURIComponent(parts[idx + 1] || "") : "";
    } catch (error) {
      return "";
    }
  }

  function ciwiPageUrl(root, panel, page) {
    const collectionUrl = panel.getAttribute("data-ciwi-collection-url");
    if (!collectionUrl) return "";
    const pageSize = ciwiPageSize(root);
    // Stay on the current preview host so unpublished theme alternate views resolve.
    const url = new URL(collectionUrl, window.location.origin);
    url.protocol = window.location.protocol;
    url.host = window.location.host;
    url.search = "";
    url.hash = "";
    url.searchParams.set("view", "ciwi-tabs-more-products");
    url.searchParams.set("page", String(page));
    url.searchParams.set("ciwi_size", String(pageSize));
    let themeId = root.getAttribute("data-preview-theme-id");
    if (!themeId) themeId = new URLSearchParams(window.location.search).get("preview_theme_id");
    if (themeId) url.searchParams.set("preview_theme_id", themeId);
    [
      ["ciwi_title", "data-ciwi-card-title"],
      ["ciwi_price", "data-ciwi-card-price"],
      ["ciwi_variants", "data-ciwi-card-variants"],
      ["ciwi_rating", "data-show-rating"],
      ["ciwi_vendor", "data-ciwi-card-vendor"],
      ["ciwi_align", "data-ciwi-card-align"],
      ["ciwi_aspect", "data-ciwi-card-aspect"]
    ].forEach((pair) => {
      const value = root.getAttribute(pair[1]);
      if (value) url.searchParams.set(pair[0], value);
    });
    return url.toString();
  }

  function ciwiSeenIds(panel) {
    const seen = new Set();
    panel.querySelectorAll("[data-ciwi-product]").forEach((item) => {
      const id = item.getAttribute("data-product-id");
      if (id) seen.add(id);
    });
    return seen;
  }

  function ciwiFormatMoney(sample, amount) {
    const value = Number(amount);
    if (!Number.isFinite(value)) return "";
    const sampleText = sample && sample.textContent ? sample.textContent : "";
    const prefix = sampleText.indexOf("$") !== -1 ? "$" : "";
    const code = (sampleText.match(/\b[A-Z]{3}\b/) || [""])[0];
    const body = prefix + value.toFixed(2);
    return code ? body + " " + code : body;
  }

  function ciwiBuildItemFromProduct(sample, product, index) {
    if (!sample) return null;
    const item = sample.cloneNode(true);
    item.classList.remove("ciwi-tabs__product--off", "ciwi-tabs__product--enter");
    item.setAttribute("data-product-id", String(product.id));
    item.setAttribute("data-index", String(index));
    item.setAttribute("data-available", product.available ? "true" : "false");
    const variant = (product.variants && product.variants[0]) || {};
    const cents = Math.round(parseFloat(variant.price || product.price || 0) * 100);
    item.setAttribute("data-price", String(Number.isFinite(cents) ? cents : 0));
    item.setAttribute("data-title", product.title || "");
    item.setAttribute("data-vendor", product.vendor || "");
    item.setAttribute("data-type", product.product_type || "");
    item.setAttribute("data-tags", JSON.stringify(product.tags || []));
    item.setAttribute("data-ciwi-options", ciwiOptionsAttrFromJsonProduct(product));
    item.setAttribute("data-ciwi-cat-images", ciwiCatImagesAttrFromJsonProduct(product));
    item.removeAttribute("data-ciwi-img-orig");
    item.removeAttribute("data-ciwi-img-orig-srcset");
    item.classList.remove("ciwi-tabs__product--cat-img");
    item.removeAttribute("data-created");
    item.querySelectorAll("script, safe-load-scripts").forEach((node) => node.remove());
    const href = "/products/" + product.handle;
    item.querySelectorAll("a[href]").forEach((anchor) => {
      const prev = anchor.getAttribute("href") || "";
      if (prev.indexOf("/products/") !== -1 || anchor.hasAttribute("data-product-card-link")) {
        anchor.setAttribute("href", href);
      }
    });
    const titleNode = item.querySelector(".product-grid--title a") || item.querySelector(".product-grid--title");
    if (titleNode) titleNode.textContent = product.title || "";
    const priceNode = item.querySelector(".product-grid--price");
    if (priceNode && variant.price) {
      const current = ciwiFormatMoney(priceNode, variant.price);
      const compare = variant.compare_at_price ? Number(variant.compare_at_price) : 0;
      const sale = Number(variant.price);
      if (compare > sale) {
        priceNode.innerHTML = "<s>" + ciwiFormatMoney(priceNode, compare) + "</s> " + current;
      } else {
        priceNode.textContent = current;
      }
    }
    const img = product.images && product.images[0];
    const imgSrc = img ? (img.src || img) : "";
    const images = item.querySelectorAll("img");
    images.forEach((image, idx) => {
      if (idx > 0) {
        image.remove();
        return;
      }
      if (!imgSrc) return;
      image.setAttribute("src", imgSrc);
      image.removeAttribute("srcset");
      image.removeAttribute("data-src");
      image.removeAttribute("data-srcset");
      if (product.title) image.setAttribute("alt", product.title);
    });
    item.querySelectorAll("[class*='swatch']").forEach((node) => node.remove());
    const rating = item.querySelector(".product-grid--rating");
    if (rating) {
      rating.innerHTML = "";
      rating.setAttribute("hidden", "");
      rating.setAttribute("data-ciwi-rating-source", "yotpo");
      rating.classList.add("ciwi-tabs__yotpo-rating");
      const widget = document.createElement("div");
      widget.className = "yotpo bottomLine";
      widget.setAttribute("data-product-id", String(product.id));
      widget.setAttribute("data-yotpo-product-id", String(product.id));
      rating.appendChild(widget);
    }
    return item;
  }

  function ciwiFetchPageFromJson(root, panel) {
    const handle = ciwiCollectionHandle(panel);
    if (!handle) return Promise.reject(new Error("handle"));
    const pageSize = ciwiPageSize(root);
    const state = ciwiMoreState(panel);
    const seen = ciwiSeenIds(panel);
    const collected = [];
    const buildResult = (hasNext) => {
      const sample = panel.querySelector("[data-ciwi-product]");
      const startIndex = ciwiSeenIds(panel).size + 1;
      const items = collected.slice(0, pageSize).map((product, index) => {
        return ciwiBuildItemFromProduct(sample, product, startIndex + index);
      }).filter(Boolean);
      return { hasNext: hasNext, items: items, pageUsed: state.nextPage };
    };
    const pull = (jsonPage) => {
      if (jsonPage > 40 || collected.length >= pageSize) {
        state.jsonPage = jsonPage;
        return Promise.resolve(buildResult(collected.length >= pageSize));
      }
      const url = new URL("/collections/" + encodeURIComponent(handle) + "/products.json", window.location.origin);
      url.searchParams.set("limit", "50");
      url.searchParams.set("page", String(jsonPage));
      return fetch(url.toString(), { credentials: "same-origin", cache: "no-store" }).then((response) => {
        if (!response.ok) throw new Error("status");
        return response.json();
      }).then((data) => {
        const products = (data && data.products) || [];
        products.forEach((product) => {
          const id = String(product.id);
          if (seen.has(id)) return;
          seen.add(id);
          collected.push(product);
        });
        if (products.length < 50) {
          state.jsonPage = jsonPage;
          return buildResult(false);
        }
        if (collected.length >= pageSize) {
          state.jsonPage = jsonPage;
          return buildResult(true);
        }
        state.jsonPage = jsonPage + 1;
        return pull(jsonPage + 1);
      });
    };
    return pull(Math.max(1, state.jsonPage || 1));
  }

  function ciwiInThemeEditor() {
    try {
      return !!(window.Shopify && Shopify.designMode);
    } catch (error) {
      return false;
    }
  }

  function ciwiFetchPage(root, panel, page, skipDuplicatePages) {
    const state = ciwiMoreState(panel);
    const inEditor = ciwiInThemeEditor();
    // products.json often hangs inside the theme editor iframe — stay on HTML there.
    if (state.preferJson && !inEditor) return ciwiFetchPageFromJson(root, panel);
    const seen = ciwiSeenIds(panel);
    const skipLeft = skipDuplicatePages == null ? 10 : skipDuplicatePages;
    return fetch(ciwiPageUrl(root, panel, page), { credentials: "same-origin", cache: "no-store" }).then((response) => {
      if (!response.ok) throw new Error("status");
      return response.text();
    }).then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const pageRoot = doc.querySelector("[data-ciwi-page]");
      if (!pageRoot) throw new Error("template");
      const serverHasNext = pageRoot.getAttribute("data-ciwi-has-next") === "1";
      const pageSize = ciwiPageSize(root);
      const unseen = Array.from(pageRoot.querySelectorAll("[data-ciwi-product]")).filter((item) => {
        const id = item.getAttribute("data-product-id");
        return id && !seen.has(id);
      });
      if (!unseen.length) {
        if (serverHasNext && skipLeft > 0) {
          return ciwiFetchPage(root, panel, page + 1, skipLeft - 1);
        }
        throw new Error("duplicate");
      }
      const items = unseen.slice(0, pageSize);
      const moreOnPage = unseen.length > items.length;
      return {
        hasNext: serverHasNext || moreOnPage,
        items: items,
        pageUsed: moreOnPage ? Math.max(0, page - 1) : page
      };
    }).catch((error) => {
      if (inEditor) throw error;
      state.preferJson = true;
      return ciwiFetchPageFromJson(root, panel);
    });
  }

  const CIWI_LOADING_MIN_MS = 520;

  function ciwiSetLoading(panel, on) {
    const loading = panel.querySelector("[data-ciwi-loading]");
    const state = ciwiMoreState(panel);
    if (!loading) return;

    if (state.loadingHideTimer) {
      window.clearTimeout(state.loadingHideTimer);
      state.loadingHideTimer = 0;
    }

    if (on) {
      state.loadingShownAt = Date.now();
      panel.classList.add("ciwi-tabs__panel--loading");
      loading.hidden = false;
      loading.setAttribute("aria-busy", "true");
      window.requestAnimationFrame(() => {
        loading.classList.add("is-visible");
      });
      return;
    }

    const hideNow = () => {
      loading.classList.remove("is-visible");
      panel.classList.remove("ciwi-tabs__panel--loading");
      loading.removeAttribute("aria-busy");
      state.loadingHideTimer = window.setTimeout(() => {
        loading.hidden = true;
        state.loadingHideTimer = 0;
      }, 340);
    };

    const elapsed = Date.now() - (state.loadingShownAt || 0);
    if (elapsed < CIWI_LOADING_MIN_MS) {
      state.loadingHideTimer = window.setTimeout(hideNow, CIWI_LOADING_MIN_MS - elapsed);
    } else {
      hideNow();
    }
  }

  function ciwiRevealAppendedProducts(panel, entered) {
    return new Promise((resolve) => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          entered.forEach((item) => {
            item.classList.remove("ciwi-tabs__product--pending");
            item.classList.add("ciwi-tabs__product--enter");
          });
          ciwiApplyCollectionFilters(panel, false);
          resolve();
        });
      });
    });
  }

  function ciwiFinishMore(panel, state) {
    state.done = true;
    ciwiSetLoading(panel, false);
    const wrap = panel.querySelector("[data-ciwi-more-wrap]");
    if (wrap) wrap.hidden = true;
    const foot = panel.querySelector("[data-ciwi-load-foot]");
    if (foot) foot.classList.add("is-done");
    const sentinel = panel.querySelector("[data-ciwi-sentinel]");
    if (sentinel) sentinel.remove();
  }

  function ciwiLoadMore(root, panel, chained) {
    const mode = root.getAttribute("data-more-mode") || "view_more";
    if (mode !== "infinite" && mode !== "load_more") return Promise.resolve();
    if (!panel.getAttribute("data-ciwi-collection-url")) return Promise.resolve();
    const list = panel.querySelector("[data-ciwi-products]");
    if (!list) return Promise.resolve();
    const state = ciwiMoreState(panel);
    const button = panel.querySelector("[data-ciwi-load-more]");
    const status = panel.querySelector("[data-ciwi-more-status]");
    const pageSize = ciwiPageSize(root);

    // Fresh user click: clear stuck busy/done from editor re-renders or a hung fetch.
    if (!chained) {
      state.paused = false;
      state.busy = false;
      if (state.done) {
        state.done = false;
        const wrap = panel.querySelector("[data-ciwi-more-wrap]");
        if (wrap) wrap.hidden = false;
        const foot = panel.querySelector("[data-ciwi-load-foot]");
        if (foot) foot.classList.remove("is-done");
      }
      state.cardCap = (state.cardCap || pageSize) + pageSize;
    }

    if (state.done || state.paused) return Promise.resolve();
    if (state.busy && !chained) return Promise.resolve();
    state.busy = true;
    if (status) status.hidden = true;
    ciwiSetLoading(panel, true);
    const seen = ciwiSeenIds(panel);
    const fetchPage = ciwiResolveNextPage(root, panel, state);

    return ciwiFetchPage(root, panel, fetchPage).then((result) => {
      state.nextPage = (result.pageUsed || fetchPage) + 1;
      let added = 0;
      const frag = document.createDocumentFragment();
      const entered = [];
      result.items.forEach((item) => {
        const id = item.getAttribute("data-product-id");
        if (id && seen.has(id)) return;
        if (id) seen.add(id);
        ciwiPrepareItem(panel, item);
        item.classList.add("ciwi-tabs__product--pending");
        frag.appendChild(item);
        entered.push(item);
        added += 1;
      });
      list.appendChild(frag);
      entered.forEach((item) => {
        item.addEventListener("animationend", () => {
          item.classList.remove("ciwi-tabs__product--enter");
        }, { once: true });
      });

      let revealPromise = Promise.resolve();
      if (added > 0) {
        revealPromise = ciwiRevealAppendedProducts(panel, entered).then(() => {
          ciwiApplyCollectionFilters(panel, false);
          ciwiEnforceCardCap(panel, root);
          window.setTimeout(() => ciwiEnforceCardCap(panel, root), 200);
          window.setTimeout(() => ciwiEnforceCardCap(panel, root), 800);
          if (!state.done) ciwiSetLoading(panel, false);
        });
      }

      const runYotpo = () => ciwiUpgradeRatings(root, panel);
      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(runYotpo, { timeout: 1200 });
      } else {
        window.setTimeout(runYotpo, 450);
      }

      if (added === 0 && result.hasNext) {
        state.emptyPageSkips = (state.emptyPageSkips || 0) + 1;
        if (state.emptyPageSkips <= 12) {
          return revealPromise.then(() => ({ chain: true, added: 0 }));
        }
      } else {
        state.emptyPageSkips = 0;
      }

      const pageSize = ciwiPageSize(root);
      const stillShort = () => ciwiVisibleCardCount(panel) < (state.cardCap || pageSize);

      if (added === 0 || !result.hasNext) {
        if (!result.hasNext) ciwiFinishMore(panel, state);
        else if (added === 0) ciwiFinishMore(panel, state);
      } else if (stillShort() && result.hasNext) {
        // Keep pulling until visible cards reach the card cap (page size), not SPU count.
        return revealPromise.then(() => ({ chain: true, added: added }));
      }
      return revealPromise.then(() => ({ chain: false, added: added }));
    }).catch(() => {
      if (status) status.hidden = false;
      // Keep sentinel so the shopper can scroll/retry; do not mark done on one failure.
      return { chain: false, added: 0 };
    }).then((meta) => {
      if (meta && meta.chain) {
        return ciwiLoadMore(root, panel, true);
      }
      state.busy = false;
      if (!state.done && (!meta || meta.added === 0)) ciwiSetLoading(panel, false);
      if (mode === "infinite" && !state.paused && !state.done && ciwiSentinelVisible(panel.querySelector("[data-ciwi-sentinel]"))) {
        window.setTimeout(() => ciwiLoadMore(root, panel), 320);
      }
    });
  }

  function ciwiTryInfiniteFromScroll(root) {
    if ((root.getAttribute("data-more-mode") || "") !== "infinite") return;
    const panel = root.querySelector("[data-panel].is-active");
    if (!panel) return;
    const state = ciwiMoreState(panel);
    if (state.paused) state.paused = false;
    if (state.busy || state.done) return;
    const sentinel = panel.querySelector("[data-ciwi-sentinel]");
    if (!ciwiSentinelVisible(sentinel)) return;
    ciwiSetLoading(panel, true);
    ciwiLoadMore(root, panel);
  }

  function initCollectionTabs(root) {
    if (root.getAttribute("data-collection-tabs-ready") === "true") return;
    root.setAttribute("data-collection-tabs-ready", "true");

    const tabs = root.querySelectorAll("[data-tab]");
    const panels = root.querySelectorAll("[data-panel]");
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const id = tab.getAttribute("data-tab");
        tabs.forEach((item) => {
          const on = item === tab;
          item.classList.toggle("is-active", on);
          item.setAttribute("aria-selected", on ? "true" : "false");
        });
        panels.forEach((panel) => {
          const on = panel.getAttribute("data-panel") === id;
          panel.classList.toggle("is-active", on);
          if (!on && panel._ciwiCloseFilterSheet) panel._ciwiCloseFilterSheet();
          if (on) ciwiEnforceCardCap(panel, root);
          if (!on || (root.getAttribute("data-more-mode") || "") !== "infinite") return;
          const sentinel = panel.querySelector("[data-ciwi-sentinel]");
          if (ciwiSentinelVisible(sentinel)) ciwiLoadMore(root, panel);
        });
      });
    });

    panels.forEach((panel) => {
      ciwiWatchCardCap(panel, root);
      ciwiEnforceCardCap(panel, root);
      ciwiWatchLinkedOptions(panel);
      ciwiBindMultiFilters(panel);
      ciwiApplyDefaultFilters(panel);
      if (ciwiApplySavedFilters(panel, ciwiReadSavedFilters(root, panel))) {
        ciwiApplyCollectionFilters(panel, false);
      }
      panel.querySelectorAll("[data-ciwi-filter], [data-ciwi-sort]").forEach((el) => {
        el.addEventListener("change", () => {
          ciwiApplyCollectionFilters(panel);
          ciwiWriteSavedFilters(root, panel);
          const state = panel._ciwiMore;
          if (state) state.paused = false;
          if ((root.getAttribute("data-more-mode") || "") === "infinite") ciwiLoadMore(root, panel);
        });
      });
      const activeFilters = panel.querySelector("[data-ciwi-active-filters]");
      if (activeFilters && !activeFilters._ciwiBound) {
        activeFilters._ciwiBound = true;
        activeFilters.addEventListener("click", (event) => {
          const clearAll = event.target.closest("[data-ciwi-filter-clear-all]");
          const clearOne = event.target.closest("[data-ciwi-filter-clear]");
          if (!clearAll && !clearOne) return;
          event.preventDefault();
          event.stopPropagation();
          if (clearAll) ciwiClearAllFilters(panel);
          else {
            ciwiClearFilterValue(
              panel,
              clearOne.getAttribute("data-ciwi-filter-clear"),
              clearOne.getAttribute("data-value")
            );
          }
          ciwiApplyCollectionFilters(panel);
          ciwiWriteSavedFilters(root, panel);
          const state = panel._ciwiMore;
          if (state) state.paused = false;
          if ((root.getAttribute("data-more-mode") || "") === "infinite") ciwiLoadMore(root, panel);
        });
      }
      const button = panel.querySelector("[data-ciwi-load-more]");
      if (button && !button._ciwiLoadBound) {
        button._ciwiLoadBound = true;
        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          ciwiLoadMore(root, panel);
        });
      }

      const filtersRoot = panel.querySelector("[data-ciwi-filters]");
      if (filtersRoot) {
        const sheet = filtersRoot.querySelector("[data-ciwi-filter-sheet]");
        const openFilterSheet = () => {
          if (sheet && sheet.parentElement !== document.body) {
            filtersRoot._ciwiSheetHome = sheet.parentElement;
            document.body.appendChild(sheet);
          }
          filtersRoot.classList.add("is-open");
          if (sheet) sheet.classList.add("is-open");
          document.documentElement.classList.add("ciwi-tabs-filter-open");
        };
        const closeFilterSheet = () => {
          filtersRoot.classList.remove("is-open");
          if (sheet) sheet.classList.remove("is-open");
          if (sheet && filtersRoot._ciwiSheetHome && sheet.parentElement === document.body) {
            filtersRoot._ciwiSheetHome.appendChild(sheet);
          }
          if (!document.querySelector("[data-ciwi-filter-sheet].is-open")) {
            document.documentElement.classList.remove("ciwi-tabs-filter-open");
          }
        };
        const openBtn = filtersRoot.querySelector("[data-ciwi-filter-open]");
        if (openBtn) openBtn.addEventListener("click", openFilterSheet);
        if (sheet) {
          sheet.querySelectorAll("[data-ciwi-filter-close]").forEach((el) => {
            el.addEventListener("click", closeFilterSheet);
          });
        }
        panel._ciwiCloseFilterSheet = closeFilterSheet;
      }
    });

    if (!root._ciwiFilterEscBound) {
      root._ciwiFilterEscBound = true;
      document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;
        ciwiCloseMultiFilters();
        root.querySelectorAll("[data-ciwi-filters].is-open").forEach((node) => {
          const panel = node.closest("[data-panel]");
          if (panel && panel._ciwiCloseFilterSheet) panel._ciwiCloseFilterSheet();
        });
      });
    }

    if (!window._ciwiMultiDocBound) {
      window._ciwiMultiDocBound = true;
      document.addEventListener("click", () => ciwiCloseMultiFilters());
    }

    ciwiScheduleRatingUpgrade(root);

    if (!root._ciwiRatingViewportBound) {
      root._ciwiRatingViewportBound = true;
      let viewportTimer = 0;
      const onViewportChange = () => {
        if (viewportTimer) window.clearTimeout(viewportTimer);
        viewportTimer = window.setTimeout(() => ciwiNudgeYotpoRatings(root), 320);
      };
      window.addEventListener("resize", onViewportChange, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", onViewportChange, { passive: true });
      }
    }

    if ((root.getAttribute("data-more-mode") || "") === "infinite") {
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const panel = entry.target.closest("[data-panel]");
            if (!panel || !panel.classList.contains("is-active")) return;
            const state = ciwiMoreState(panel);
            if (state.paused) state.paused = false;
            if (state.busy || state.done) return;
            ciwiSetLoading(panel, true);
            ciwiLoadMore(root, panel);
          });
        }, { rootMargin: "280px" });
        root._ciwiObserver = observer;
        root.querySelectorAll("[data-ciwi-sentinel]").forEach((node) => observer.observe(node));
      }
      if (!root._ciwiScrollBound) {
        root._ciwiScrollBound = true;
        const onScroll = () => ciwiTryInfiniteFromScroll(root);
        window.addEventListener("scroll", onScroll, { passive: true });
        document.addEventListener("scroll", onScroll, { passive: true, capture: true });
        root._ciwiScrollHandler = onScroll;
      }
      // Kick once after paint (theme editor iframe often needs a nudge).
      window.setTimeout(() => ciwiTryInfiniteFromScroll(root), 300);
    }
  }

  function ciwiBindGlobalLoadMore() {
    if (document._ciwiTabsLoadMoreBound) return;
    document._ciwiTabsLoadMoreBound = true;
    // Capture phase: theme editor stops bubbling on preview clicks.
    document.addEventListener("click", (event) => {
      const button = event.target && event.target.closest
        ? event.target.closest("[data-ciwi-load-more]")
        : null;
      if (!button) return;
      const panel = button.closest("[data-panel]");
      const root = button.closest("[data-collection-tabs]");
      if (!panel || !root) return;
      event.preventDefault();
      event.stopPropagation();
      ciwiLoadMore(root, panel);
    }, true);
  }

  ciwiBindGlobalLoadMore();
  document.querySelectorAll("[data-collection-tabs]").forEach(initCollectionTabs);
  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector
      ? event.target.querySelector("[data-collection-tabs]")
      : null;
    if (root) {
      root.removeAttribute("data-collection-tabs-ready");
      initCollectionTabs(root);
      if (ciwiRatingShowEnabled(root)) {
        window.setTimeout(() => ciwiRebootstrapRatings(root), 60);
      }
    }
  });
  document.addEventListener("shopify:section:unload", (event) => {
    const root = event.target.querySelector
      ? event.target.querySelector("[data-collection-tabs]")
      : null;
    if (!root) return;
    if (root._ciwiRatingSettingObs) {
      root._ciwiRatingSettingObs.disconnect();
      root._ciwiRatingSettingObs = null;
    }
    if (root._ciwiObserver) root._ciwiObserver.disconnect();
    root.querySelectorAll("[data-panel]").forEach((panel) => {
      if (panel._ciwiLinkedObs) {
        panel._ciwiLinkedObs.disconnect();
        panel._ciwiLinkedObs = null;
      }
    });
    if (root._ciwiScrollHandler) {
      window.removeEventListener("scroll", root._ciwiScrollHandler);
      document.removeEventListener("scroll", root._ciwiScrollHandler, true);
    }
    root.removeAttribute("data-collection-tabs-ready");
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["style-tabs"] && !Shopify.designMode) return;
  try {
    
  function syncStyleTabArrows(panel) {
    const track = panel.querySelector(".ciwi-style-tabs__track");
    const prev = panel.querySelector(".ciwi-style-tabs__arrow--prev");
    const next = panel.querySelector(".ciwi-style-tabs__arrow--next");
    if (!track || !prev || !next) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = max <= 0 || track.scrollLeft >= max;
  }

  function initStyleTabs(root) {
    if (root.getAttribute("data-style-tabs-ready") === "true") return;
    root.setAttribute("data-style-tabs-ready", "true");

    const tabs = root.querySelectorAll("[data-tab]");
    const panels = root.querySelectorAll("[data-panel]");

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const id = tab.getAttribute("data-tab");
        tabs.forEach((item) => {
          const on = item === tab;
          item.classList.toggle("is-active", on);
          item.setAttribute("aria-selected", on ? "true" : "false");
        });
        panels.forEach((panel) => {
          const on = panel.getAttribute("data-panel") === id;
          panel.classList.toggle("is-active", on);
          if (!on) return;
          const track = panel.querySelector(".ciwi-style-tabs__track");
          if (track) track.scrollLeft = 0;
          syncStyleTabArrows(panel);
        });
      });
    });

    panels.forEach((panel) => {
      const track = panel.querySelector(".ciwi-style-tabs__track");
      const prev = panel.querySelector(".ciwi-style-tabs__arrow--prev");
      const next = panel.querySelector(".ciwi-style-tabs__arrow--next");
      if (!track || !prev || !next) return;
      const step = () => {
        const card = track.querySelector(".ciwi-style-tabs__card");
        return card ? card.getBoundingClientRect().width + 14 : 400;
      };
      prev.addEventListener("click", () => {
        track.scrollBy({ left: -step(), behavior: "smooth" });
      });
      next.addEventListener("click", () => {
        track.scrollBy({ left: step(), behavior: "smooth" });
      });
      track.addEventListener("scroll", () => syncStyleTabArrows(panel));
      if (panel.classList.contains("is-active")) syncStyleTabArrows(panel);
    });
  }

  document.querySelectorAll("[data-style-tabs]").forEach(initStyleTabs);
  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector("[data-style-tabs]");
    if (root) initStyleTabs(root);
  });
  if (!window.__ciwiStyleTabsResize) {
    window.__ciwiStyleTabsResize = true;
    window.addEventListener("resize", () => {
      document.querySelectorAll("[data-style-tabs] [data-panel].is-active").forEach(syncStyleTabArrows);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
